import {
  Button,
  ButtonProps,
  mergeSx,
  useDrawerInstance,
  Stack,
  tokens,
} from '@cast/design-system';

import type { StackProps } from '@cast/design-system';

type Props = StackProps & {
  closeButtonProps?: ButtonProps;
  saveButtonProps?: ButtonProps;
  sticky?: boolean;
};

export const FormDrawerFooter = ({
  closeButtonProps,
  saveButtonProps,
  sticky,
  ...props
}: Props) => {
  const { close } = useDrawerInstance();
  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      bgcolor={tokens.theme.bg.structural.surface}
      px={32}
      py={10}
      gap={16}
      sx={mergeSx(
        props.sx,
        sticky && {
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          // Add border as pseudo element to not impact overall height
          '&:before': {
            content: '""',
            position: 'absolute',
            height: '1px',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: tokens.theme.border.structural.neutral,
          },
        }
      )}
      data-testid="form-drawer-footer"
      {...props}
    >
      <Button
        variant="secondary"
        testId="close-btn"
        onClick={() => close()}
        {...closeButtonProps}
      >
        Close
      </Button>
      <Button type="submit" testId="save-btn" {...saveButtonProps}>
        Save
      </Button>
    </Stack>
  );
};
